'use strict';

var blz = window.blz || {};

var HTTPService = {
  base: function base(type, url, data, headers, params) {
    var hasProtocol = url.indexOf('http') > -1;
    var ajaxOptions = $.extend(
      {},
      {
        url: hasProtocol ? url : blz.domain + url,
        type: type,
        data: data || {},
        headers: headers || {},
        params: params || {}
      }
    );

    return $.ajax(ajaxOptions);
  },
  get: function get(url, params, data) {
    return this.base('GET', url, data, null, params);
  },
  post: function post(url, data, headers) {
    return this.base(
      'POST',
      url,
      JSON.stringify(data),
      headers || { 'content-type': 'application/json' }
    );
  },
  put: function put(url, data, headers) {
    return this.base(
      'PUT',
      url,
      JSON.stringify(data),
      headers || { 'content-type': 'application/json' }
    );
  },
  delete: function (url) {
    return this.base('DELETE', url);
  },

  handleClientError: function handleClientError(data, _status, response) {
    if (response.status >= 400) {
      throw new Error(HTTPService.parseFirstError(data));
    }

    return data;
  },

  parseFirstError: function parseFirstError(data) {
    data = data.responseJSON || data;

    try {
      data = JSON.parse(data.responseText);
    } catch (o_O) {
      //
    }

    if (typeof data === 'string') {
      return blz.locale[data] || data;
    }

    var arr = data instanceof Array ? data : [data];
    console.log(blz.locale[arr[0].message]);

    return blz.locale[arr[0].logref || arr[0].message] || blz.locale['try_again'];
  }
};

module.exports = HTTPService;
